module.exports = __webpack_public_path__ + "media/images/news/icon_facebook-ec5defc0754bbdfb4dc942779f9c5f97.svg";